// extracted by mini-css-extract-plugin
export const head = "summary-module--head--1EAn7";